module.exports = __webpack_public_path__ + "static/img/inDevelop.56ff530.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/inDevelop.jpeg
// module id = Uh5G
// module chunks = 1